import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
  isBrowser,
  isMobile,
  MobileView,
  BrowserView,
} from 'react-device-detect';
import DashBoard from '../../layouts/Dashboard';
import SignUpLayout from '../../layouts/SignUp';
import SignUpFormLayout from '../../layouts/SignUpForm';
import SignIn from '../../pages/SignIn';

import ClientAccount from '../../pages/User-Client/Account';
import NewPassword from '../../pages/Templates/NewPassword';
import SignUpAccountType from '../../pages/SignUpAccountType';
import SignUp from '../../pages/SignUp';
import SignUpInfo from '../../pages/SignUpInfo';
import PageNotFound from '../../components/PageNotFound/PageNotFound';
import LandingPage from '../../layouts/LandingPage/';
import Client from '../../pages/User-Client';
// import LandingPage from '../../pages/LandingPage';
import AdditionalInfo from '../../pages/AditionalInfo';
import Articles from '../../pages/Articles';
import ArticleView from '../../pages/ArticleView';
import ArticleCategory from '../../pages/ArticleCategory';

import SignInClient from '../../pages/User-Client/Account/signInClient';

//import Sandbox from './Sandbox/';
import * as ROUTES from '../../routes';
// import Sandbox from './../../layouts/Dashboard/SideMenu';
// import Sandbox1 from './Sandbox';
import '../../utils/typography';
import '../../components/App.scss';

class App extends Component {
  render() {
    return (
      <>
        
          {/* <Route exact path="/Sandbox1" component={Sandbox1} /> */}
          {/* <Route exact path="/Sandbox" component={Sandbox} /> */}
          {/* <Route exact path="/Sandbox/:id" component={Sandbox} /> */}
          {/* <Route exact path={ROUTES.SIGNIN} component={SignIn} />
          <Route path="/ingresa/newpassword" component={NewPassword} />
          <Route exact path="/ingresa/recuperar-contasena" component={SignIn} />
          <Route exact path={ROUTES.HOME} component={DashBoard} />
          <Route exact path={ROUTES.ACCOUNT} component={DashBoard} />
          <Route exact path={ROUTES.MESSAGES} component={DashBoard} />
          <Route exact path={ROUTES.OPINIONS} component={DashBoard} />
          <Route exact path={ROUTES.NOTIFICATIONS} component={DashBoard} />
          <Route exact path={ROUTES.MEMBERSHIP} component={DashBoard} />
          <Route exact path={ROUTES.ANALYTICS} component={DashBoard} />
          <Route exact path={ROUTES.PAYMENTPROCESS} component={DashBoard} />
          <Route
            exact
            path={ROUTES.ADDITIONAL_INFO}
            component={AdditionalInfo}
          />
          <Route exact path={ROUTES.LANDING_PAGE} component={LandingPage} />
          <Route exact path={ROUTES.PROFILE} component={DashBoard} />
          <Route exact path={ROUTES.ARTICLES} component={LandingPage} />
          <Route
            exact
            path={`${ROUTES.ARTICLES}/:category/:postId`}
            component={LandingPage}
          />
          <Route
            exact
            path={`${ROUTES.ARTICLES}/:category`}
            component={LandingPage}
          /> */}


{/*           <Route exact path={ROUTES.SIGN_IN_MAIN_CLIENT } component={Client} />
 */}         {/*  <Route exact path={ROUTES.SIGN_UP_CLIENT } component={Client} /> */}

          
          {/*  If you want to display url to ClientAccount You don`t need put exact */}
         {/*  <Route  path={ROUTES.CLIENT_ACCOUNT} component={ClientAccount} /> */}
          
          {/* <BrowserView> */}
          {isBrowser && (
            <>
              <SignUpLayout>
                <SignUpFormLayout>
                  <Switch>
                    <Route
                    exact
                      path={ROUTES.SIGNUP}
                      component={SignUpAccountType}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWYER_INFO}
                      component={SignUpInfo}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWYER}
                      component={SignUp}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWFIRM_INFO}
                      component={SignUpInfo}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWFIRM}
                      component={SignUp}
                    />
                    <Route component={PageNotFound} />
                  </Switch>
                </SignUpFormLayout>
              </SignUpLayout>
            </>
          )}
          {/* </BrowserView> */}

          {/* <MobileView> */}
          {isMobile && (
            <>
              <div style={{ height: '100vh' }}>
                <SignUpFormLayout>
                  <Switch>
                    <Route
                      exact
                      path={ROUTES.SIGNUP}
                      component={SignUpAccountType}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWYER_INFO}
                      component={SignUpInfo}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWYER}
                      component={SignUp}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWFIRM_INFO}
                      component={SignUpInfo}
                    />
                    <Route
                      exact
                      path={ROUTES.SIGNUP_LAWFIRM}
                      component={SignUp}
                    />
                  </Switch>
                </SignUpFormLayout>
              </div>
            </>
          )}
          {/* </MobileView> */}
        
      </>
    );
  }
}

export default App;
